module.exports = __webpack_public_path__ + "static/media/setting.15be7c38.svg";